export default __webpack_public_path__ + "static/media/ic-unselected.daaacab5.svg";